import React, {useState} from "react"
import MetaTags from 'react-meta-tags';
import {
  Container, 
  Card, CardBody,
  CardTitle, CardSubtitle,
  CardText, CardHeader, 
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
  Button,
  TabContent, 
  TabPane,
  Row, 
  Col,
  Input,
  Table,
  Alert
} from "reactstrap"
import { Link, useHistory } from "react-router-dom"
import { get, post } from "../../../helpers/api_helper"
import * as url from "../../../helpers/url_helper"
import cogoToast from 'cogo-toast';
import Select from "react-select"
import { connect } from "react-redux"

const NewBuilding = props => {

  const history = useHistory();

  const [name, setName] = useState('');
  const [status, setStatus] = React.useState(1);

  const [errors, setErrors] = React.useState([]);
  
  const [loading, setLoading] = React.useState(false);
  const [initializing, setInitializing] = React.useState(true);

  const fetchData = (id) => {
    setLoading(true);
      console.log('Fetching ', id);
      get(url.GET_BUILDING+'/'+id).then(response => {
      console.log('RESP', response);
      if(response.status == 200) {
        setName(response.data.name);
        setStatus(response.data.status);
        setLoading(false);
      }
      else {
        cogoToast.error('Could not fetch building data');
        setLoading(false);
      }
    })
    .catch(error => {
      console.log('err:', error);
    });
  };


  const handleSubmit = () => {
    if(name == '') {
      cogoToast.error('Building name is required');
      return;
    }

    let data = {
      id: props.match.params.id ? props.match.params.id : 'new',
      name: name,
      status: status,
      property_id: props.filterProperty.id,
      block_id: props.filterBlock.id,
      // repeat: repeat ? 1 : 0,
    };

    console.log('data', data);
    // return;

    setLoading(true);
    setErrors([]);
    // axios.post('/api/beacon/create', {
    post(url.POST_NEW_BUILDING, data)
    .then((response) => {
      console.log('RESP', response);
      if(response.status == 200) {
        history.push('/buildings/index');
        cogoToast.success('Building '+ (props.match.params.id ? (props.match.params.id == 'new' ? 'added' : 'updated') : 'added') + ' successfully');
      }
      else if(response.status == 400) {
        setErrors(Object.values(response.error));
      }
      else {
        console.log('err::', response);
      }
      // if(response == true) {
      // }
      // if(response.status == 200) {
      //   if(response.data == 'input') {
      //     cogoToast.error('Please check your input');
      //     setLoading(false);
      //   }
      //   else if(response.data == 'exists') {
      //     cogoToast.error('Beacon name is already taken');
      //     setLoading(false);
      //   }
      //   else {
      //     props.insertItem(response.data);
      //   }
      // }
      // else {
      //   cogoToast.error('Beacon could not be created');
      //   setLoading(false);
      // }
    }, (error) => {
      console.log(error);
      setLoading(false);
    });

  };

  React.useEffect(()=>{

    if(props.match.params.id && props.match.params.id !== 'new') {
      // setName(props.match.params.id.name);
      fetchData(props.match.params.id);
    }
  }, []);

  // console.log('params:', props.match.params.id);

  // const displayedBlocks = blocks.length < 1 ? [] : blocks.filter(b => property == null ? false : b.property_id == property.value);

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{props.match.params.id ? (props.match.params.id == 'new' ? 'Add New' : 'Edit') : 'Add New'} Building | Digital Logbook</title>
        </MetaTags>
        <Container fluid>
          <div className="d-flex justify-content-between align-items-center">
            <h3 className="mb-4">{props.match.params.id ? (props.match.params.id == 'new' ? 'New' : 'Edit') : 'New'} building</h3>
            <Link className="btn btn-secondary" to="/buildings/index">Back</Link>
          </div>


          {errors.length > 0 &&
          <div className="mt-3 mb-5">
            {errors.map((error, errorIdx)=>(
              <Alert key={errorIdx} color="danger">
                <i className="mdi mdi-alert-circle-outline me-2"></i>{error}
              </Alert>
            ))}
          </div>
          }

          <Card>
            <CardBody>
              {/* <CardTitle tag="h3">BASIC DETAILS</CardTitle> */}
              {/* <CardSubtitle tag="h5" className="mb-4 text-muted">22 Jul 2021</CardSubtitle> */}
              <div className="row mt-2">
                <div className="col">
                  <div className="mb-4 row">
                    <label htmlFor="activityName" className="col-sm-3 col-form-label">Building Name</label>
                    <div className="col-sm-9">
                      <input autoFocus type="text" className="form-control" id="name"  value={name} onChange={e=>{ setName(e.target.value); }} />
                    </div>
                  </div>

                  <div className="mb-4 row">
                    <label htmlFor="status" className="col-sm-3 col-form-label">Status</label>
                    <div className="col-sm-9">
                      <select className="form-control" placeholder="Select one" 
                        value={status}
                        onChange={(e)=>{ setStatus(e.target.value); }}
                        >
                        <option value="1">Active</option>
                        <option value="0">Inactive</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </CardBody>
          </Card>


     </Container>

    <div className="mb-4 container">
      <div className="d-flex justify-content-center">
        <button type="button" className="btn btn-primary me-2" onClick={()=>{ handleSubmit(); }}>Submit</button>
        <Link className="btn btn-light" to="/buildings/index">Cancel</Link>
      </div>
    </div>
      </div>
    </React.Fragment>
  )
}

const mapStatetoProps = (state) => {
  const {
    filterBlock,
    filterProperty
  } = state.filters
  return { filterBlock, filterProperty }
}

export default connect(mapStatetoProps)(NewBuilding)